import {createContext} from 'react'

const SearchContext = createContext({
  switchFn: () => {},
  handleResults: () => {},
  engine: {},
  posts:[]
})

export default SearchContext